import React, { useState } from 'react'
import { Table, TableHeader, TableRow } from 'features/Table'
import Button from 'components/Button'
import sMarg from 'styles/modules/margins.scss'
import s from './PhoneSystemDidNumbersAvailableTable.scss'
import { Input } from 'components/Input/Input'
import LoadingLinear from 'components/Loading/LoadingLinear'
import {
  useSearchPhoneSystemDidNumbersQuery,
  SearchPhoneSystemDidNumbersQuery,
} from 'src/generated/graphql'
import { WrappedFieldProps } from 'redux-form'

export interface IPhoneSystemDidNumbersAvailableTableProps extends WrappedFieldProps {
  input: WrappedFieldProps['input'] & {
    value: SearchPhoneSystemDidNumbersQuery['searchPhoneSystemDIDNumbers']
    onChange: (val: SearchPhoneSystemDidNumbersQuery['searchPhoneSystemDIDNumbers']) => void
  }
  maxDIDNumbers: number
}

export const PhoneSystemDidNumbersAvailableTable = (
  props: IPhoneSystemDidNumbersAvailableTableProps
) => {
  const value: SearchPhoneSystemDidNumbersQuery['searchPhoneSystemDIDNumbers'] =
    props.input.value || []
  const selectedIds = value.map(item => item.id)
  const [query, setQuery] = useState<string>()

  const { data, loading } = useSearchPhoneSystemDidNumbersQuery({
    variables: {
      query: query || '1',
    },
  })

  const onChange = (
    item: SearchPhoneSystemDidNumbersQuery['searchPhoneSystemDIDNumbers'][0],
    selected: boolean
  ) => {
    const newVal: SearchPhoneSystemDidNumbersQuery['searchPhoneSystemDIDNumbers'] =
      selected === true
        ? [...value, item]
        : value.filter(existingItem => existingItem.id !== item.id)

    props.input.onChange(newVal)
  }

  const tableHeader = (
    <TableHeader>
      <div>Number</div>
      <div>Location</div>
      <div style={{ maxWidth: '96px' }} />
    </TableHeader>
  )

  const resultsNotSelected =
    data?.searchPhoneSystemDIDNumbers.filter(item => !selectedIds.includes(item.id)) || []

  const allResults = [...value, ...resultsNotSelected]

  return (
    <div>
      <div className={sMarg.mb30}>
        <Input
          label="Search numbers"
          type="number"
          input={{
            value: query,
            onChange: e => {
              setQuery(e.target.value)
            },
          }}
          meta={{}}
        />
      </div>
      <Table header={tableHeader} className={s.table}>
        {allResults.map(item => {
          const isSelected = selectedIds.includes(item.id)
          return (
            <TableRow key={item.id}>
              <div>{item.number}</div>
              <div>{item.city}</div>
              <div style={{ maxWidth: '96px' }}>
                <Button
                  onClick={() => onChange(item, !isSelected)}
                  color="tertiary"
                  size="xs"
                  ghost={!isSelected}
                  disabled={!isSelected && selectedIds.length >= props.maxDIDNumbers}
                >
                  {isSelected ? 'Selected' : 'Select'}
                </Button>
              </div>
            </TableRow>
          )
        })}
        {resultsNotSelected.length === 0 && <TableRow>No more results</TableRow>}
        {loading && (
          <div>
            <br />
            <br />
            <LoadingLinear />
          </div>
        )}
      </Table>
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemDidNumbersAvailableTable/PhoneSystemDidNumbersAvailableTable.tsx